import React from "react";
import "./ViewProjectSkeleton.css";

export default function ViewProjectSkeleton() {
  return (
    <div className="project-skeleton">

      {/* HEADER */}
      <div className="skeleton-header">
        <div className="skeleton skeleton-title"></div>

        <div className="skeleton-meta">
          <div className="skeleton skeleton-text short"></div>
          <div className="skeleton skeleton-text short"></div>
          <div className="skeleton skeleton-badge"></div>
        </div>
      </div>

      {/* DESKTOP SECTIONS */}
      <div className="skeleton-sections desktop-only">

        <div className="skeleton-card">
          <div className="skeleton skeleton-section-title"></div>
          <div className="skeleton skeleton-text"></div>
          <div className="skeleton skeleton-text"></div>
        </div>

        <div className="skeleton-card">
          <div className="skeleton skeleton-section-title"></div>
          <div className="skeleton skeleton-row"></div>
          <div className="skeleton skeleton-row"></div>
        </div>

        <div className="skeleton-card">
          <div className="skeleton skeleton-section-title"></div>
          <div className="skeleton skeleton-row"></div>
          <div className="skeleton skeleton-row"></div>
          <div className="skeleton skeleton-row"></div>
        </div>

      </div>

      {/* MOBILE ACCORDION STYLE */}
      <div className="skeleton-accordion mobile-only">

        {[1,2,3,4].map((i) => (
          <div key={i} className="skeleton-accordion-item">
            <div className="skeleton skeleton-accordion-header"></div>
          </div>
        ))}

      </div>

    </div>
  );
}